import React from "react";
import {
  defineBlock,
  smartProps,
  useEditor,
  EditableDiv,
  ChildrenBlock,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import { InnerBlocks } from "@wordpress/block-editor";

function Block() {
  const { isEditing } = useEditor();

  return (
    <div className={style.block}>
      <EditableDiv className={style.title} smartProp="title" />
      {isEditing ? (
        <InnerBlocks
          allowedBlocks={["smartfire/froid-product-specs-list"]}
          templateLock={false}
        />
      ) : (
        <ChildrenBlock />
      )}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Froid - Container Liste specs produit",
    parent: ["smartfire/froid-product-specs"],
  },
});
